module.exports = __webpack_public_path__ + "static/media/logo.2e964d04.svg";